module.exports = __webpack_public_path__ + "cb45d51cb5a29ab9307ae301551790ab.MP3";